import styled, { css } from 'styled-components';
import colors from '../../helpers/colors';
import fonts from '../../helpers/fonts';
import mediaQuery from '../../helpers/mediaQuery';
import spacing from '../../helpers/spacing';
import { Grid } from '../Grid';
import Icon from '../Icon';
import SimplePanel from '../Panel/SimplePanel';

export const StyledPanel = styled(SimplePanel)<{
  hasHeading?: boolean;
  isCollapsed?: boolean;
}>`
  background-color: ${colors.neutral07};

  padding: ${spacing(3)};

  ${mediaQuery.tabletLandscape`
    padding: ${spacing(4)}
  `};

  ${({ hasHeading }) =>
    hasHeading &&
    css`
      padding-top: ${spacing(1)};

      ${mediaQuery.tabletLandscape`
          padding-top: ${spacing(1)};
      `};
    `}

  ${({ isCollapsed }) =>
    !isCollapsed &&
    css`
      padding-bottom: ${spacing(1)};

      ${mediaQuery.tabletLandscape`
          padding-bottom: ${spacing(1)};
      `};
    `}
`;

export const GridWithMargins = styled(Grid)`
  && {
    margin-top: ${spacing(3)};
    margin-bottom: ${spacing(3)};

    ${mediaQuery.tabletPortrait`
      margin-top: ${spacing(4)};
      margin-bottom: ${spacing(4)};
    `}
  }
`;

export const StyledHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin: ${spacing(2)} 0;
`;

export const StyledHeaderTitle = styled.h3`
  ${fonts.headingSmall}
  display: flex;
  gap: ${spacing(2)};
  align-items: flex-start;
  ${mediaQuery.tabletLandscape`
    align-items: center;
  `}
  margin: 0;
`;

export const StyledCollapseContainer = styled.div`
  display: flex;
  gap: ${spacing(1)};
  align-items: center;
  cursor: pointer;
`;

export const StyledCollapseText = styled.p`
  ${fonts.paragraphSmall}
  margin: 0;
`;

export const StyledHeadingIcon = styled(Icon)`
  margin-top: ${spacing(0.7)};
  ${mediaQuery.tabletPortrait`
  margin-top: 0;
`}
`;
